import { AppState } from 'Src/store'
import { createSelector } from 'reselect'
import { arrayToShortDataArray } from 'Pages/orders_design'

const getAddresses = (state: AppState) => state.orders_design.sberGeoUnit.addresses
const getTownItems = createSelector(getAddresses, (address) =>
	arrayToShortDataArray(address.town_names)
)
const getAddressesParams = (state: AppState) => state.orders_design.sberGeoUnit.addressesParams

export const sberGeoUnitSelectors = {
	getAddresses,
	getTownItems,
	getAddressesParams,
}
